/**
 * Logica pura do bonus por "% sobre referencia" exibido na tabela de metas
 * calculadas (Task 23) — quanto o percentual informado pelo usuario daria
 * hoje sobre a comissao P2 do colaborador na competencia da campanha.
 *
 * Extraido de TabelaMetasCalculadas.vue para ser testado sem montar o
 * componente, mesmo padrao de tabelaMetasCalculadasUtils.js.
 *
 * Importante: isto e so exibicao. O bonus persistido continua sendo
 * origem + percentual (ver payloadMetaExtras.montarExtrasMeta) — nunca o
 * valor calculado aqui.
 */

/**
 * percentual/100 vezes a comissao do colaborador na competencia.
 *
 * Colaborador ausente do mapa (sem comissao P2 na competencia — ver
 * mapearComissaoP2Consorcio em consorcioMapper.js) vale zero, nao null.
 * A versao anterior devolvia null pra tabela exibir travessao, distinguindo
 * "sem comissao" de "comissao zero". A distincao nao se sustenta na regra
 * desta campanha: a apuracao vai atualizando o bonus conforme a comissao P2
 * do mes cresce, entao quem hoje nao tem comissao tem bonus de zero — um
 * valor, nao uma incognita. O travessao passava a impressao errada de que o
 * numero seria conhecido depois por outro caminho.
 *
 * O campo de percentual desta tela guarda string (decisao anterior desta
 * branch, ver BonusComissaoReferencia.vue) — parseFloat cobre isso.
 * @param {number|string} percentual
 * @param {number|string|undefined|null} comissao
 * @returns {number}
 */
export function calcularBonusReferencia(percentual, comissao) {
  const p = parseFloat(percentual) || 0;
  return (p / 100) * (parseFloat(comissao) || 0);
}

const MESES_ABREV = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

/**
 * Extrai {mes_ref, ano_ref} da resposta de comissao().tipoFechamento().show
 * filtrada por id_tipo_fechamento — mesmo formato ja lido em
 * FormCadastroCampanha.findIdTipoFechamento (checkPeriodoFechamento.data[0]).
 * @param {Array<{mes_ref, ano_ref}>} itens
 * @returns {{mes_ref, ano_ref}|null}
 */
export function extrairCompetenciaFechamento(itens) {
  const lista = itens || [];
  if (!lista.length) return null;
  const { mes_ref, ano_ref } = lista[0];
  return { mes_ref, ano_ref };
}

/**
 * Formata a competencia para o rotulo da coluna, ex.: "jul/2026".
 *
 * Sem a competencia no cabecalho o usuario le a coluna como "o bonus que
 * vai receber" — e nao e: enquanto o mes nao fecha, a comissao (e portanto
 * o valor exibido) ainda cresce. Com a competencia visivel, fica claro que
 * e uma referencia daquele mes, nao um valor definitivo.
 * @param {{mes_ref, ano_ref}|null} competencia
 * @returns {string}
 */
export function formatarCompetencia(competencia) {
  if (!competencia) return "";
  const mes = Number(competencia.mes_ref);
  const abrev = MESES_ABREV[mes - 1] || "";
  return `${abrev}/${competencia.ano_ref}`;
}
